// 导入 axios
import axios from 'axios'
/*ElementUI*/
import ele from 'element-ui'
// vuex
import router from '../router/index.js'
	import {
		apiBaseUrl
	} from './config.js';
// 默认请求格式
// 创建 axios 实例
const requests = axios.create({
	//baseURL: '/api', // 基础url,如果是多环境配置这样写，也可以像下面一行的写死。
	baseURL:apiBaseUrl+'/',
	
	timeout: 6*10*1000 // 请求超时时间
})

// 退出登录
function exit() {
	// 清除Token
	localStorage.removeItem("Authorization");
	// 清除存储用户信息
	localStorage.removeItem("member");
	localStorage.removeItem("admin");
	// 清除登录
	localStorage.removeItem("isLogin");
	router.push('/');
}

// 错误处理函数
const err = (error) => {
	// 请求错误时做些事
	let status = "";
	if (error.request) {
		status = error.request;
	} else if (error.response) {
		status = error.response;
	}
	if (status) {
		switch (status.status) {
			case 400:
				error.message = "请求错误(400)";
				break;
			case 401:
				error.message = "未授权，请重新登录(401)";
				exit()
				break;
			case 403:
				error.message = "登录过期，请重新登录";
				exit()
				break;
			case 404:
				error.message = "请求出错(404)";
				break;
			case 408:
				error.message = "请求超时(408)";
				break;
			case 500:
				error.message = "服务器错误(500)，请稍后重试";
				break;
			case 501:
				error.message = "服务未实现(501)";
				break;
			case 502:
				error.message = "网络错误(502)";
				break;
			case 503:
				error.message = "服务不可用(503)";
				break;
			case 504:
				error.message = "网络超时(504)";
				break;
			case 505:
				error.message = "HTTP版本不受支持(505)";
				break;
			default:
				error.message = `连接出错(${status.status})!`;
		}
	} else {
		error.message = "连接服务器失败!";
	};
	if (error.message) {
		ele.Message({
			message: error.message,
			type: 'error'
		})
	}

	return Promise.reject(error)
}

// 公开接口白名单（不需要登录的接口）
const publicApiList = [
	'article/',           // 文章相关
	'ad/list',            // 广告列表
	'dict-data/list',     // 字典数据
	'send/getCode',       // 发送验证码
	'verify/login',       // 登录
	'verify/register',    // 注册
	'area/tree',          // 地区树
	'cooperation/apply',  // 合作申请
	'product/price-group/list',// 产品价格组列表
	'product/search',     // 产品搜索
	'product/detail',     // 产品详情
];

// 需要登录的接口路径前缀（匹配这些前缀的接口都需要登录）
const authRequiredPrefixes = [];

// 判断接口是否需要登录
function isAuthRequired(url) {
	if (!url) return false;
	
	// 先检查是否在白名单中（公开接口）
	const isPublic = publicApiList.some(api => url.includes(api));
	if (isPublic) return false;
	
	// 检查是否需要登录的路径前缀
	return authRequiredPrefixes.some(prefix => url.includes(prefix));
}

// request interceptor(请求拦截器)
requests.interceptors.request.use(config => {
	const token = localStorage.getItem('Authorization');
	console.log(config.url,11111111)
	if(config.url!='admin-api/auth/app/login'){
		config.headers['Content-Type'] = 'multipart/form-data';
	}
	if (token) {
		
		config.headers['Authorization'] = 'Bearer '+token // 让每个请求携带自定义 token
		
		config.headers['clientId'] = localStorage.getItem('clientId');
	} else {
		// 如果接口需要登录但token不存在，拦截请求
		if (isAuthRequired(config.url)) {
			ele.Message({
				message: '請先登錄',
				type: 'warning'
			});
		router.push('/login');
			ele.ElLoading.close()
			// 取消请求
			return Promise.reject(new Error('未登录'));
		}
	}

	return config
}, err)

// response interceptor（接收拦截器）
requests.interceptors.response.use(response => {
	const res = response.data;
	if (res.code == 401) {
		ele.Message({
			message: '請先登錄',
			type: 'error'
		});
		router.push('/login');
	} else if (res.code != 206 && res.code != 200 && res.code != 0 && res.code != 203) {
		// 除 200 || 0 以外的消息提示
		console.log(res,111111111)
		if (res.msg) {
			ele.Message({
				message: res.msg,
				type: 'error'
			})
		};
		
		return Promise.reject(res);
	}
	return res;
}, err)

export default requests